import axios from "axios";

import * as types from "./types";
import {
  API_URL,
  ACTIVE, CANCELED, PENDING, SUSPENDED,
  formatUnixTimestamp
} from '../common/constants';
// user actions

export const createUser = (userData) => {
  if (userData.fullName) {
    //separate into firstName and lastName
    const [firstName, ...rest] = userData.fullName.split(" ");
    const lastName = rest.join(" ");
    userData.first_name = firstName;
    userData.last_name = lastName;
    delete userData.fullName;
  }

  return async (dispatch) => {
    try {
      // Make an API call to send registration data
      const response = await axios.post(`${API_URL}/user/create`, userData);
      console.log('createUser.response', response);

      if (response.status === 201) {
        const user = response.data;
        dispatch({
          type: 'CREATE_USER',
          payload: user
        });

        return user;
      } else {
        //throw new Error('Registration failed');
        const error = response?.data;
        return error;
      }
    } catch (error) {
      console.log('Error registering user: ', error);
      return error;
    }
  };
};

export const updateUser = (userData) => {
  return async (dispatch) => {
    try {
      // Make an API call to send registration data
      const response = await axios.post(`${API_URL}/user/update/${userData.user_id}`, userData);
      console.log('updateUser.response', response);

      if (response.status === 200) {
        const updateResponse = response.data;
        dispatch({
          type: 'UPDATE_USER',
          payload: updateResponse
        });

        return updateResponse;
      } else {
        //throw new Error('Registration failed');
        const error = response?.data;
        return error;
      }
    } catch (error) {
      console.log('Error updating user state: ', error);
      return error;
    }
  };
};

export const deleteUser = (userData) => {

};

export const checkout = (data) => {
  return async (dispatch) => {
    try {
      // Make an API call to send registration data
      const response = await axios.post(`${API_URL}/merchant/stripe/charge`, data);
      console.log('subscribe.response', response);

      if (response?.data?.success === true) {
        const charge = response.data;
        const subscriptionData = {
          success: response.data.success,
          subscriptionId: charge?.dbSubscription?.id,
          gatewaySubscriptionId: charge?.dbSubscription?.gateway_subscription_id,
          gatewayPlanId: charge?.dbSubscription?.gateway_plan_id,
          status: charge?.dbSubscription?.status,
          startDate: charge?.dbSubscription?.start_date,
          endDate: charge?.dbSubscription?.end_date,
          nextChargeDate: charge?.dbSubscription?.next_charge_date,
          amount: charge?.dbSubscription?.amount
        };
        dispatch({
          type: 'CREATE_SUBSCRIPTION',
          payload: subscriptionData
        });

        const billingData = {
          success: response.data.success,
          billingId: charge?.dbBilling?.id,
          subscriptionId: charge?.dbBilling?.subscription_id,
          transactionId: charge?.dbBilling?.transaction_id,
          amount: charge?.dbBilling?.amount,
          cardNumber: charge?.dbBilling?.card_number,
          cardExpMonth: charge?.dbBilling?.card_exp_month,
          cardExpYear: charge?.dbBilling?.card_exp_year,
          responseCode: charge?.dbBilling?.gateway_response_code,
        };
        dispatch({
          type: 'CREATE_BILLING',
          payload: billingData
        });

        return true;
      } else {
        dispatch({
          type: 'CREATE_SUBSCRIPTION',
          payload: { success: response.data.success, error: response?.data?.error }
        });
        return false;
      }
    } catch (error) {
      dispatch({
        type: 'CREATE_SUBSCRIPTION',
        payload: { success: false, error: 'Error submitting payment' }
      });
      return false;
    }
  };
};

export const createRecipient = (userData) => {
  return async (dispatch) => {
    try {
      // Make an API call to send registration data
      const response = await axios.post(`${API_URL}/user/create-recipient`, userData);
      console.log('createUser.response', response);

      if (response.status === 200) {
        const recipient = response.data;
        dispatch({
          type: 'CREATE_RECIPIENT',
          payload: recipient
        });

        return recipient;
      } else {
        //throw new Error('Registration failed');
        const error = response?.data;
        return error;
      }
    } catch (error) {
      console.log('Error registering user: ', error);
      return error;
    }
  };
};

export const updateRecipient = (userData) => {
  return async (dispatch) => {
    try {
      // Make an API call to send registration data
      const response = await axios.post(`${API_URL}/user/update/${userData.user_id}`, userData);
      console.log('updateRecipient.response', response);

      if (response.status === 200) {
        const recipient = response.data;
        dispatch({
          type: 'UPDATE_RECIPIENT',
          payload: recipient
        });

        return recipient;
      } else {
        //throw new Error('Registration failed');
        const error = response?.data;
        return error;
      }
    } catch (error) {
      console.log('Error updating contact: ', error);
      return error;
    }
  };
};

export const createGroup = (data) => {
  return async (dispatch) => {
    try {
      // Make an API call to send registration data
      const response = await axios.post(`${API_URL}/user/create-group`, data);
      console.log('createGroup.response', response);

      if (response.status === 200) {
        const group = response.data;
        if (group.success) {
          dispatch({
            type: 'CREATE_GROUP',
            payload: group
          });

          return group;
        } else {
          return false;
        }
      } else {
        //throw new Error('Registration failed');
        const error = response?.data;
        return error;
      }
    } catch (error) {
      console.log('Error creating group: ', error.message);
      return error;
    }
  };
};

export const createGroupMember = (data) => {
  return async (dispatch) => {
    try {
      // Make an API call to send registration data
      const response = await axios.post(`${API_URL}/user/create-group-members`, data);
      console.log('createGroupMember.response', response);

      if (response.status === 200) {
        const payload = response.data;
        const groupMembers = payload?.groupMembers;
        if (payload.success) {
          if (groupMembers.length > 0) {
            dispatch({
              type: 'CREATE_GROUP_MEMBER',
              payload: payload
            });
            return groupMembers;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        //throw new Error('Registration failed');
        const error = response?.data;
        return error;
      }
    } catch (error) {
      console.log('Error creating group member: ', error.message);
      return error;
    }
  };
};

export const deleteGroupMember = (data) => {
  return async (dispatch) => {
    try {
      // Make an API call to send registration data
      const response = await axios.post(`${API_URL}/user/delete-group-member`, data);
      console.log('deleteGroupMember.response', response);

      if (response.status === 200) {
        return response?.data;
      } else {
        //throw new Error('Registration failed');
        const error = response?.data;
        return error;
      }
    } catch (error) {
      console.log('Error creating group member: ', error.message);
      return error;
    }
  };
};

export const setGroupMemberAsPrimary = (data) => {
  return async (dispatch) => {
    try {
      // Make an API call to send registration data
      const response = await axios.post(`${API_URL}/user/set-group-member-as-primary`, data);
      console.log('setGroupMemberAsPrimary.response', response);

      if (response.status === 200) {
        return response?.data;
      } else {
        //throw new Error('Registration failed');
        const error = response?.data;
        return error;
      }
    } catch (error) {
      console.log('Error creating group member: ', error.message);
      return error;
    }
  };
};

export const getUsers = (data) => {
  return async (dispatch) => {
    try {
      // Make an API call to send registration data
      const response = await axios.post(`${API_URL}/user/list`, data);
      console.log('getUsers.response', response);

      const users = response?.data;
      //console.log('users', users);
      //dispatch({
      //type: 'GET_USERS',
      //payload: users
      //});

      return users;

    } catch (error) {
      console.log('Error getting users: ', error);
      return false;
    }
  };
};